import EllipsisContent from "@/Common/Component/EllipsisContent";
import { useTeamContext } from "@/Common/Contex/TeamContext";
import useConfig from "@/hooks/useConfig";
import { Box, Button, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PageRoutes from "@/utils/constants";
import { useNavigate } from "react-router-dom";
const TeamNameRow = ({ liveGame, subscriptionDetails }: any) => {
  const { setCurrentSelectedTeam, currentSelectedTeam }: any = useTeamContext();
  const config = useConfig();
  const navigate = useNavigate();
  return (
    <Box>
      <Box
        sx={{
          bgcolor:
            currentSelectedTeam?.team_secondary_color || config.secondary,
          width: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          pl: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 1,
            py: 1,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <img
            src={currentSelectedTeam?.team_logo_url}
            alt="Team Logo"
            style={{ width: 60, height: 60, objectFit: "contain" }}
          />
          <Box>
            <EllipsisContent
              text={(
                currentSelectedTeam?.team_name +
                " " +
                currentSelectedTeam?.team_mascot
              ).toUpperCase()}
              //   maxTextWidth={200}
              sx={{
                fontSize: 36,
                color:
                  currentSelectedTeam?.team_primary_color || config.primary,
                lineHeight: "36px",
                fontStyle: "normal",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontStyle: "normal",
                textTransform: "none",
                color:
                  currentSelectedTeam?.team_primary_color || config.primary,
              }}
            >
              0 Followers
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Button
              variant="contained"
              sx={{
                bgcolor:
                  currentSelectedTeam?.team_primary_color || config.primary,
                color:
                  currentSelectedTeam?.team_secondary_color || config.secondary,
                "&:hover": {
                  bgcolor:
                    currentSelectedTeam?.team_primary_color || config.primary,
                  color:
                    currentSelectedTeam?.team_secondary_color ||
                    config.secondary,
                },
              }}
            >
              Follow
            </Button>
            {!!liveGame && (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    PageRoutes.Watch.replace(":gameId", liveGame?.game_id)
                  );
                }}
                startIcon={<PlayCircleIcon />}
                sx={{
                  fontWeight: 600,
                  bgcolor:
                    currentSelectedTeam?.team_primary_color || config.primary,
                  color:
                    currentSelectedTeam?.team_secondary_color ||
                    config.secondary,
                  "&:hover": {
                    bgcolor:
                      currentSelectedTeam?.team_primary_color || config.primary,
                    color:
                      currentSelectedTeam?.team_secondary_color ||
                      config.secondary,
                  },
                }}
              >
                Live Now
              </Button>
            )}
            {subscriptionDetails?.status !== "active" && (
              <Button
                variant="contained"
                onClick={() => navigate(PageRoutes.Packages)}
                sx={{
                  bgcolor:
                    currentSelectedTeam?.team_primary_color || config.primary,
                  color:
                    currentSelectedTeam?.team_secondary_color ||
                    config.secondary,
                  "&:hover": {
                    bgcolor:
                      currentSelectedTeam?.team_primary_color || config.primary,
                    color:
                      currentSelectedTeam?.team_secondary_color ||
                      config.secondary,
                  },
                }}
              >
                Subscribe
              </Button>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            height: 100,
            position: "relative",
            display: { xs: "none", lg: "block" },
          }}
        >
          <Box
            sx={{
              position: "relative",
              height: 100,
              width: 300,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                backgroundImage: `url(${
                  currentSelectedTeam?.overlay_configuration
                    ? JSON.parse(
                        currentSelectedTeam?.overlay_configuration || ""
                      )?.logo_right
                    : currentSelectedTeam?.team_logo_url
                })`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundPositionY: "-8px",
                height: "100%",
                width: "100%",
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            />
            {/* Gradient overlay for left-to-right opacity effect */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: `linear-gradient(to right, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                } 0%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }CC 20%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }99 40%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }66 60%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }33 80%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }00 100%)`,
                zIndex: 1,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default TeamNameRow;
